<template>

    <section class="c-settings_notifications">
        <h3>Powiadomienia mailowe o wizycie</h3>
        <form @submit.prevent="updateNotifications">
            <form-desc>Wyślij powiadomienia na adres email o zbliżającej się wizycie:</form-desc>
            <form-switch
                label="1 dzień przed wizytą"
                v-model="pht.notification_to_patient_one_day_before_visit">
            </form-switch>
            <form-switch
                label="2 dni przed wizytą"
                v-model="pht.notification_to_patient_two_days_before_visit">
            </form-switch>
            <form-switch
                label="3 dni przed wizytą"
                v-model="pht.notification_to_patient_three_days_before_visit">
            </form-switch>
            <form-row align="right">
                <v-btn
                    type="green"
                    role="submit"
                    has-loader
                    :loading="isLoading">
                    Zapisz
                </v-btn>
            </form-row>
        </form>
    </section>

</template>


<script>

import {FormRow, FormSwitch, FormDesc} from 'Components/Form'
import VBtn from 'Components/VBtn'
import {mapGetters} from 'vuex';

export default {

    name: 'SettingsNotifications',

    data() {
        return {
            isLoading: false
        }
    },

    computed: {
        ...mapGetters(['pht'])
    },

    methods: {
        updateNotifications() {
            this.isLoading = true
            this.$store.dispatch('PHT_NOTIFICATIONS_UPDATE', {
                notification_to_patient_one_day_before_visit: this.pht.notification_to_patient_one_day_before_visit,
                notification_to_patient_two_days_before_visit: this.pht.notification_to_patient_two_days_before_visit,
                notification_to_patient_three_days_before_visit: this.pht.notification_to_patient_three_days_before_visit
            }).then((result) => {
                this.isLoading = false
                this.$alert.success('Powiadomienia', 'Harmonogram powiadomień został zaktualizowany')

            }).catch((error) => {
                this.isLoading = false
                this.$alert.error('Powiadomienia', error.response.data.message)
            })
        }
    },

    components: {
        FormRow,
        FormSwitch,
        FormDesc,
        VBtn
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-settings_notifications {

}

</style>
